import { useDataFetchingClient } from 'data-fetching-client';
import { useAblyChannel } from '../../pubsub/hooks/useAblyChannel';
import { getCurrentPortalChannel } from '../../pubsub/utils';
import { USER_CAPACITY_LIMIT_V2_UPDATE } from '../constants';
import Raven from 'raven-js';
import { useCallback, useRef } from 'react';
import { updateCachedCapacityLimit } from '../clients/cache';
import { GET_CURRENT_USER_CAPACITY_DATA_QUERY, GET_USER_CAPACITY_DATA_QUERY } from '../../../__generated__/chirp/com/hubspot/cv/assignments/rpc/UserCapacityLimitsV2Service.dfc.new';
import { useUserInfo } from '../../auth/hooks/useUserInfo';
/**
 * This hook is meant to be used alongside fetch calls to GET_USER_CAPACITY_DATA_QUERY or GET_CURRENT_USER_CAPACITY_DATA_QUERY
 * It can be put anywhere but it should be in a component that is not remounted often as it will make a new connection.
 * In the future we may have changes to reuse connections more efficiently,
 * but use of a singleton has caused issues in the past so we don't do that.
 */
export const useRealtimeUserLevelCapacityLimits = () => {
  const userInfo = useUserInfo();
  const authUserId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user.user_id;
  const latestUpdateTimestampRef = useRef(0);
  const portalChannel = getCurrentPortalChannel();
  const dfcClient = useDataFetchingClient();
  const onMessage = useCallback(message => {
    if (!authUserId) {
      return;
    }
    const lastUpdated = latestUpdateTimestampRef.current;
    const isLatestMessage = message.timestamp > lastUpdated;
    if (isLatestMessage) {
      updateCachedCapacityLimit({
        capacityLimitMessage: message,
        client: dfcClient,
        authUserId
      });
    }
  }, [dfcClient, authUserId]);
  const onReconnect = useCallback(() => {
    dfcClient.refetchQueries({
      include: [GET_USER_CAPACITY_DATA_QUERY, GET_CURRENT_USER_CAPACITY_DATA_QUERY]
    }).catch(e => Raven.captureException(e));
  }, [dfcClient]);
  const onPlayback = useCallback(messages => {
    messages.forEach(onMessage);
  }, [onMessage]);
  useAblyChannel({
    channel: portalChannel,
    type: USER_CAPACITY_LIMIT_V2_UPDATE,
    onMessage,
    onPlayback,
    onReconnect
  });
};